<template>
	<v-dialog v-model="mostrar" persistent max-width="70vw" scrollable>
		<v-card max-height="600px">
			<v-toolbar dark flat color="primary">
				<v-spacer></v-spacer>
				<v-checkbox class="mt-5" v-model="artigoLocal.status_leitura" true-value="realizada" false-value="pendente" :label="textoLeitura"></v-checkbox>
			</v-toolbar>
			<v-divider></v-divider>
            <v-card-text>
				<v-container>
					<v-row>
						<v-col cols="12">
							<div v-html="artigo.conteudo"></div>
						</v-col>
					</v-row>
				</v-container>
            </v-card-text>
            <v-card-actions>
				<v-spacer></v-spacer>
				<v-btn text color="primary" @click="exportar()">Exportar</v-btn>
				<v-btn text color="primary" @click.stop="fechar()">Fechar</v-btn>
			</v-card-actions>
		</v-card>
    </v-dialog>
</template>

<script>
	//import jsPDF from 'jspdf'
	import axios from 'axios'
	import {mapState} from 'vuex'
	import { baseApiUrl, showError, showSuccess } from "@/config/global"

	export default{
		props:['artigo', 'mostrar'],
		data(){
			return{
				artigoLocal: {}
			}
		},
		computed:{
			... mapState(['user']),
			textoLeitura(){
				return this.artigoLocal.status_leitura == "realizada" ? "Desmarcar leitura" : "Marcar como lido"
			}
		},
		methods:{
			fechar(){
				this.$emit("update:mostrar", false)
			},

			atualizarLeitura(){

				const url = `${baseApiUrl}/estudos/atualizarLeitura.php?`

				let params = {
					artigo:  this.artigoLocal.id,
					iniciado:  this.user.iniciado,
					statusLeitura:  this.artigoLocal.status_leitura
				}
				/////////////////////
				axios.post(url, params).then(res => {

					if(res.data.codigo == '01'){
						showSuccess(res.data.mensagem)
						
						this.$emit('update:artigo', this.artigoLocal)
						
						
					}else if(res.data.codigo != '05'){
						showError(res.data.mensagem)
					}
				})
				.catch({showError})
			},

			exportar(){
				 //let doc = new jsPDF()
				 //doc.fromHTML(this.artigo.conteudo, 10, 10, {"width": 140})
				 // doc.save('a4.pdf')

				let janela = window.open('','','width=800,height=680')
				janela.document.write(this.artigo.conteudo)
				janela.document.close()
				janela.print()
			}
		},

		watch:{
			mostrar(val){
				if(val){
					this.artigoLocal = this.artigo
				}
			},
			'artigoLocal.status_leitura'(){
				
				this.atualizarLeitura()
			}
		}
	}
</script>

<style scoped>

</style>